export default __webpack_public_path__ + "static/media/2293.8e5e7998.png";